import React from "react";
import "./index.css";

function Button({ onClick,children }) {
  return <button onClick={onClick} className="button">{children}</button>;
}

export default Button;
